// Small outline glyphs (24-unit grid, currentColor). Always decorative: the control that
// holds one carries the accessible name (aria-label or visible text).
import type { ReactNode } from 'react';

function Glyph({ size = 20, children }: { size?: number; children: ReactNode }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      {children}
    </svg>
  );
}

type P = { size?: number };

export const PencilIcon = ({ size }: P) => <Glyph size={size}><path d="M4 20h4L19 9a2.8 2.8 0 0 0-4-4L4 16v4z" /><path d="M13.5 6.5l4 4" /></Glyph>;
/** The UNIT "U", drawn as an outline. */
export const UnitIcon = ({ size }: P) => <Glyph size={size}><path d="M5 4v9a7 7 0 0 0 14 0V4" /><path d="M9.5 4v9a2.5 2.5 0 0 0 5 0V4" /></Glyph>;
export const ImageIcon = ({ size }: P) => <Glyph size={size}><rect x="3.5" y="4.5" width="17" height="15" rx="2.5" /><circle cx="9" cy="10" r="1.6" /><path d="M20.5 16l-5-5-8.5 8.5" /></Glyph>;
export const PaletteIcon = ({ size }: P) => (
  <Glyph size={size}>
    <path d="M12 3.5a8.5 8.5 0 1 0 0 17c1.2 0 1.8-.8 1.8-1.7 0-1.2-1-1.5-1-2.6 0-.9.7-1.6 1.6-1.6h2.1a3.9 3.9 0 0 0 4-4C20.5 6.8 16.7 3.5 12 3.5z" />
    <circle cx="7.6" cy="11.2" r="1" /><circle cx="10.4" cy="7.4" r="1" /><circle cx="15" cy="7.6" r="1" />
  </Glyph>
);
export const LockIcon = ({ size }: P) => <Glyph size={size}><rect x="5" y="10.5" width="14" height="10" rx="2.5" /><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5" /><path d="M12 14.5v2" /></Glyph>;
export const LinkIcon = ({ size }: P) => <Glyph size={size}><path d="M10 14a4 4 0 0 0 5.7 0l3.1-3.1a4 4 0 0 0-5.7-5.7l-1.2 1.2" /><path d="M14 10a4 4 0 0 0-5.7 0l-3.1 3.1a4 4 0 0 0 5.7 5.7l1.2-1.2" /></Glyph>;
export const CloseIcon = ({ size }: P) => <Glyph size={size}><path d="M6 6l12 12M18 6L6 18" /></Glyph>;
export const CheckIcon = ({ size }: P) => <Glyph size={size}><path d="M5 12.5l4.5 4.5L19 7.5" /></Glyph>;
export const ChevronIcon = ({ size }: P) => <Glyph size={size}><path d="M9.5 6l6 6-6 6" /></Glyph>;
export const PlusIcon = ({ size }: P) => <Glyph size={size}><path d="M12 5v14M5 12h14" /></Glyph>;
export const CopyIcon = ({ size }: P) => <Glyph size={size}><rect x="8.5" y="8.5" width="11" height="11" rx="2.5" /><path d="M15.5 8.5V6.5a2 2 0 0 0-2-2h-7a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h2" /></Glyph>;
export const ShareIcon = ({ size }: P) => <Glyph size={size}><circle cx="6.5" cy="12" r="2.3" /><circle cx="17.5" cy="6" r="2.3" /><circle cx="17.5" cy="18" r="2.3" /><path d="M8.5 10.9l7-3.8M8.5 13.1l7 3.8" /></Glyph>;
